<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          Файлы <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Добавить файл
          <i v-on:click="newCall" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="true" :hide-pages="true" :page-limits="pageLimits" :tuning="false"
             :new-one="newOne" :objects="objects"
             :default-sort="date" :default-sort-direction="false"
             @resetNew="newOne = null"></big-one>
  </div>
</template>
<script>

import {
  BaseInput,
  Card
} from "@/components/index";

import {sorter} from "@/services/utils";
import {authHeader} from "@/services/auth-header";
import {userService} from "@/services/user.service";

const fileName = {header: "Файл", name: "name", show: true, sort: true, direction: true}
const fileDescription = {header: "Описание", name: "description", show: true}

export default{
  components:{
    Card,
    BaseInput
  },
  props:{
    item: {},
    parentType: null
  },
  data() {
    return {
      content: [fileName, fileDescription],
      type: "file",
      pageLimits: {},
      newOne: null,
      objects: []
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    newCall() {
      let object = {id: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit', parent: this.parentType, parentId: this.item.id});
    }
  },
  async mounted() {
    let id = this.item.id
    this.pageLimits[this.parentType] = id;
    this.objects = await this.$repo.getByURL(this.parentType + '/file/' + id);
  }
}
</script>
<style>
</style>
